import { render } from "./stDataChart.vue?vue&type=template&id=0024dd5c&scoped=true"
import script from "./stDataChart.vue?vue&type=script&lang=js"
export * from "./stDataChart.vue?vue&type=script&lang=js"

import "./stDataChart.vue?vue&type=style&index=0&id=0024dd5c&scoped=true&lang=scss"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0024dd5c"]])

export default __exports__